import { useEffect, useState } from "react";
import { EditUserDataType } from "../../Enums/EditUserDataType";
import { FaEnvelope, FaLock, FaTimes } from "react-icons/fa";
import VerificationCodeInput from "../VerificationCodeInput/VerificationCodeInput";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

type VerificationCodeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (code: string) => void;
  method?: EditUserDataType;
};

const VerificationCodeModal = ({ 
  isOpen, 
  onClose, 
  onSuccess,
  method 
}: VerificationCodeModalProps) => {
  const [code, setCode] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    if (isOpen) {
      setCode("");
      setErrorMessage("");
    }
  }, [isOpen]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const handleSubmit = async () => {
    if (!code.trim()) {
      setErrorMessage("Por favor, preencha o código de verificação.");
      return;
    }
    
    onSuccess(code);
    setErrorMessage("");
    setCode("");
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-md shadow-xl px-6 py-9 relative w-full max-w-3xl">
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-primary-600 hover:text-primary-700 text-2xl font-bold"
        >
          <FaTimes />
        </button>

        <div className="flex flex-col items-center justify-center gap-4">
          {method === EditUserDataType.Email && (
            <FaEnvelope className="text-primary-600 text-xl" />
          )}

          {method === EditUserDataType.Password && (
            <FaLock className="text-primary-600 text-xl" />
          )}
          
          <h4 className="text-lg font-bold">
            {method === EditUserDataType.Email && "ALTERAR E-MAIL"}
            {method === EditUserDataType.Password && "ALTERAR SENHA"}
          </h4>  

          <div className="w-full flex flex-col items-center justify-center gap-2">
            <p>
              {`Para realizarmos a alteração ${
                  method === EditUserDataType.Email ? "do seu e-mail" : method === EditUserDataType.Password ? "da sua senha" : ""
                }, enviamos um código de verificação pelo WhatsApp, para o celular cadastrado.`}
            </p>

            <VerificationCodeInput
              length={6}
              value={code}
              onChange={setCode}
            />
          
            <Button 
              onClick={handleSubmit} 
              className="block mx-auto px-16 py-2 mt-7"
            >
              {"CONFIRMAR"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VerificationCodeModal;
